import { render, staticRenderFns } from "./MatchEventListCard.vue?vue&type=template&id=774d4301&scoped=true"
import script from "./MatchEventListCard.vue?vue&type=script&lang=js"
export * from "./MatchEventListCard.vue?vue&type=script&lang=js"
import style0 from "./MatchEventListCard.vue?vue&type=style&index=0&id=774d4301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d4301",
  null
  
)

export default component.exports